import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=17b6489d&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b6489d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b6489d')) {
      api.createRecord('17b6489d', component.options)
    } else {
      api.reload('17b6489d', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=17b6489d&scoped=true&", function () {
      api.rerender('17b6489d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jMfztW0VSlyx/JS/comp/Accordion.vue"
export default component.exports